import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA70dr43Y9Zw370-4IGn7NGelQgIdpn_QQ",
  authDomain: "sanitas-website-e2510.firebaseapp.com",
  projectId: "sanitas-website-e2510",
  storageBucket: "sanitas-website-e2510.firebasestorage.app",
  messagingSenderId: "277698844745",
  appId: "1:277698844745:web:c362be92d05aae9f858798"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
